import {type UIElement, UI} from "../../../stem-core/ui/UIBase.js";
import {AnchoredPopup, AnchoredPopupStyle} from "../../../stem-core/ui/AnchoredPopup.jsx";
import {styleRuleInherit} from "../../../stem-core/decorators/Style";
import {registerStyle} from "../../../stem-core/ui/style/Theme";

// TODO have an invisible scrim, that also passes through all click events (so another element can be toggled)
// TODO this should probably be merged with the Modal class in the future (at least in a base class)
export class DashboardAnchoredPopupStyle extends AnchoredPopupStyle {
    @styleRuleInherit
    popup = {
        border: "1px solid rgba(0,0,0,0.1)",
        boxShadow: "0 0 5px 0 rgba(0,0,0,0.2)",
        padding: 8,
    };
}

@registerStyle(DashboardAnchoredPopupStyle)
export class DashboardAnchoredPopup extends AnchoredPopup {
    getDefaultOptions(options?: this["options"]) {
        return {
            ...super.getDefaultOptions(options),
            offset: 10,
        };
    }
}


export class PopupInput extends DashboardAnchoredPopup {
    declare resolvePromise?: ((result: any) => void) | undefined;
    hide(response: unknown = null) {
        super.hide();
        if (this.resolvePromise) {
            this.resolvePromise(response);
        }
    }

    handleInputChange(value: unknown) {
        this.hide(value);
    }

    // Will show an input, and on a second call with the same anchor will hide the previous one (
    static async prompt<T = any>(InputClass: new (...args: any[]) => UIElement<Record<string, any>>, inputOptions: Record<string, any> = {}, modalOptions: Record<string, any> = {}): Promise<T | null> {
        let modal: PopupInput;
        const handleInput = inputOptions?.onChange ?? ((value: unknown) => modal?.handleInputChange(value));
        const inputElement = <InputClass {...inputOptions} onChange={handleInput} onSave={handleInput} />;
        modal = this.show({children: [inputElement], ...modalOptions});

        if (!modal) {
            return null;
        }

        return new Promise<T>(resolve => {
            modal.resolvePromise = (result) => {
                delete modal.resolvePromise;
                resolve(result);
            };
        });
    }
}
